/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeambulazioneAusilioDTO
 */
export interface DeambulazioneAusilioDTO {
    /**
     * 
     * @type {string}
     * @memberof DeambulazioneAusilioDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DeambulazioneAusilioDTO
     */
    descrizione?: string;
}

/**
 * Check if a given object implements the DeambulazioneAusilioDTO interface.
 */
export function instanceOfDeambulazioneAusilioDTO(value: object): value is DeambulazioneAusilioDTO {
    return true;
}

export function DeambulazioneAusilioDTOFromJSON(json: any): DeambulazioneAusilioDTO {
    return DeambulazioneAusilioDTOFromJSONTyped(json, false);
}

export function DeambulazioneAusilioDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeambulazioneAusilioDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
    };
}

export function DeambulazioneAusilioDTOToJSON(value?: DeambulazioneAusilioDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'descrizione': value['descrizione'],
    };
}

